class ProductCardQuickAdd extends Theme.Component {
  connectedCallback() {
    this.events();
  }

  disconnectedCallback() {}

  singleQuickAdd(_, element) {
    const container = element.closest(".spinner-container");
    if (container) {
      container.classList.add("state--loading");
    }

    const input = element.querySelector("input[data-variant-id]");
    if (!input) {
      if (container) {
        container.classList.remove("state--loading");
      }
      return;
    }

    this.addToCart(input.dataset.variantId, container);
  }

  toggleQuickAdd() {
    this.classList.toggle("is-active");
  }

  variantQuickAdd(_, element) {
    const container = element.closest(".spinner-container");
    if (container) {
      container.classList.add("state--loading");
    }

    element.classList.add("is-selected");
    const input = element.querySelector("input[data-variant-id]");
    if (!input) {
      if (container) {
        container.classList.remove("state--loading");
      }
      return;
    }

    this.addToCart(input.dataset.variantId, container);
  }

  addToCart(variantId, container) {
    if (!variantId) {
      if (container) {
        container.classList.remove("state--loading");
      }
      return;
    }

    const data = new FormData();
    data.set("id", variantId);

    fetch("/cart/add.js", {
      method: "POST",
      body: data,
    })
      .then((res) => res.json())
      .then((response) => {
        document.dispatchEvent(
          new CustomEvent("addtocart", { detail: response })
        );
        this.classList.remove("is-active");
        this.querySelectorAll(".quickadd-option").forEach((el) => el.classList.remove("is-selected"));
      })
      .catch((error) => {
        console.error("ProductCardQuickAdd: add to cart failed", error);
      })
      .finally(() => {
        if (container) {
          container.classList.remove("state--loading");
        }
      });
  }
}

customElements.define("product-card-quickadd", ProductCardQuickAdd);

class UpsellQuickadd extends Theme.Component {
  connectedCallback() {
    this.events();
    this.form = this.querySelector("form");
    this.container = this.querySelector(
      ".upsell-quickadd:not(.visibility--none)"
    );
  }

  disconnectedCallback() {}

  toggleQuickAdd() {
    this.classList.toggle("is-active");
  }

  addToCart(variantId, container, isCartGift = false) {
    console.log("UpsellQuickadd: addToCart called", variantId);
    if (!variantId) {
      if (container) {
        container.classList.remove("state--loading");
      }
      return;
    }

    const data = new FormData();
    data.set("id", variantId);

    if (isCartGift) {
      data.set("properties[_cart_gift]", "true");
    }

    console.log("UpsellQuickadd: isCartGift", isCartGift);
    console.log("UpsellQuickadd: property _cart_gift", data.get("properties[_cart_gift]"));

    fetch("/cart/add.js", {
      method: "POST",
      body: data,
    })
      .then((res) => res.json())
      .then((response) => {
        console.log("UpsellQuickAdd: added to cart", response);
        document.dispatchEvent(
          new CustomEvent("addtocart", { detail: response })
        );
        this.classList.remove("is-active");
        this.querySelectorAll(".quickadd-option").forEach((el) => el.classList.remove("is-selected"));
      })
      .catch((error) => {
        console.error("UpsellQuickAdd: add to cart failed", error);
      })
      .finally(() => {
        if (container) {
          container.classList.remove("state--loading");
        }
      });
  }

  addVariant(_, element) {
    const container = element.closest(".spinner-container");
    if (container) {
      container.classList.add("state--loading");
    }

    element.classList.add("is-selected");
    const variantId = element.dataset.variantId;
const isCartGift = element.dataset.cartGift === 'true';
const properties = isCartGift ? { _cart_gift: 'true' } : {};

console.log('quick add variant id:', variantId);
console.log('quick add is cart gift:', isCartGift);
console.log('quick add properties:', properties);

    if (!variantId) {
      if (container) {
        container.classList.remove("state--loading");
      }
      return;
    }

    this.addToCart(variantId, container, isCartGift);
  }

}

customElements.define("upsell-quickadd", UpsellQuickadd);
